module.exports = __webpack_public_path__ + "static/bracu-1-ae1e6971e08a34856361d2c64156432f.jpg";